// ----------------------------------------------------------------------------
// Component: Footer
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/newsletter-form/newsletter-form';
import 'snippets/icon/icon';
import 'snippets/menu/menu';
import 'sections/newsletter/newsletter';

// Styles
import './_footer.scss';